import React from 'react';
import { costRows } from '../data/content';
export function CostSection() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:px-5 sm:py-20" data-id="element-35" data-mp="9c6jrf0j6pu2">
      <div className="mx-auto max-w-4xl" data-id="element-36" data-mp="9eaizjnhj0o0">
        <h2 className="text-center text-xl font-extrabold uppercase text-white sm:text-3xl" data-id="element-37" data-mp="4kg1mmvcqxs3">
          ⚖️ ¿Cuánto cuesta no tenerlo?
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border border-white/10" data-id="element-38" data-mp="3vpetl9o8kt8d">
          <div className="grid grid-cols-2 bg-ink-700" data-id="element-39" data-mp="3qtzdsc6o4n9b">
            <p className="p-4 text-xs font-extrabold text-white sm:p-5 sm:text-sm" data-id="element-40" data-mp="3mqb7rxxopzq6">
              Sin Sistema
            </p>
            <p className="p-4 text-xs font-extrabold text-red-400 sm:p-5 sm:text-sm" data-id="element-41" data-mp="3hsj4y8vi4t77">
              Costo real
            </p>
          </div>
          <ul data-id="element-42" data-mp="3cuzt1fma0sif">
            {costRows.map(row => <li key={row.without} className="grid grid-cols-2 border-t border-white/10 bg-ink-800" data-id="element-43" data-mp="1fz217gahschq">
                <span className="p-4 text-xs text-gray-300 sm:p-5 sm:text-sm" data-id="element-44" data-mp="p7l3o6mqsvb7">
                  {row.without}
                </span>
                <span className="p-4 text-xs font-semibold text-red-300 sm:p-5 sm:text-sm" data-id="element-45" data-mp="t9eza0i2z94i">
                  {row.cost}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="mt-10 text-center text-lg font-extrabold text-white sm:text-xl" data-id="element-46" data-mp="k9jm5q4yt41u">
          El próximo lunes puede ser diferente.
        </p>
      </div>
    </section>;
}